export default __webpack_public_path__ + "static/media/MISTRZ_SPRYTU.36d80445.png";